/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterDeleted = new PostFilter([
  ['deletedAt', PostFilterComparison.not_null],
]);
